// extracted by mini-css-extract-plugin
export default {"container":"SearchBar_container__xwaer","invisible":"SearchBar_invisible__h5V+c"};